import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import Button from '../components/ui/Button';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Сторінку не знайдено</h2>
        <p className="text-gray-600 mb-8">
          Сторінка, яку ви шукаєте, не існує або була переміщена.
        </p>
        <Button to="/" icon={<Home size={16} />} className="mx-auto">
          На головну сторінку
        </Button>
      </div>
    </div>
  );
};

export default NotFound;